export const assetCallbackModel = {
  loading: false,
  submit() {
    console.log('submit')
  },
}

const asset = {
  namespaced: true,

  state: {
    resourceManagersDialog: {
      visible: false,
      model: {},
      defaultTab: '',
      tabKeyList: [],
    },
    resourceUploader: {
      activeRules: [],
      accepts: [],
      maxSize: 0,
      type: '', // 为龙骨、序列帧这种特殊类型zip文件校验使用
      skeleton_type: 0, // 模型的骨骼类型 同模型库
    },
    assetsDialog: {
      visible: false,
      loading: false,
      checkbox: false, // PT 只能选一个资源
      model: {},
      message: '',
      rules: {},
    },
  },

  mutations: {
    updateAssetsDialog(state, data) {
      Object.assign(state.assetsDialog, data)
    },
    updateResourceManagerDialog(state, data) {
      Object.assign(state.resourceManagersDialog, data)
    },
    updateResourceUploader(state, data) {
      Object.assign(state.resourceUploader, data)
    },
  },

  actions: {
    addAssetToProject({ state, commit }, data) {
      if (typeof assetCallbackModel.submit === 'function') {
        assetCallbackModel.submit(data)
      }
    },
  },
}

export default asset
